export default __webpack_public_path__ + "static/media/generalico.86f322ce.svg";